class ChartEvent {
  /** @deprecated Use PanelEvent.OPEN instead */
  static OPEN = 'ChartEvent.OPEN';

  /** @deprecated Use PanelEvent.CLOSE instead */
  static CLOSE = 'ChartEvent.CLOSE';

  static COLUMN_SELECTED = 'ChartEvent.COLUMN_SELECTED';
}

export default ChartEvent;
